import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { Container, Form } from 'react-bootstrap';
import { formatDate, getWeekDetails, sumMoney, displayStoredDate, partyLabel, formatAmount } from './../../helper';
import Select from '../../Components/PCSelect';
import axios from "axios";
import Swal from "sweetalert2";
import RemoveIcon from '@mui/icons-material/Delete';
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES, ToggleSwitch } from './shared/txStyles';
import AmountInput from '../../Components/AmountInput';
import PageHeader from './shared/PageHeader';
/** @type {any} */
let _inventoryCache = null;

export default class WarehouseRefundItem extends Component {
    constructor(props) {
        super(props);
        let dateObj = new Date();
        let { weekId, dates } = getWeekDetails(dateObj);
        let shopPaymentDays = dates.map(d => ({ DateAndDay: d }));
        this.state = {
            addSale: false,
            SaleList: [],
            ItemList: [],

            Customer: "",
            SALE_TO_TYPE: "Customer",
            ShopList: [],
            SaleToShop: "",

            Date: formatDate(dateObj.toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],

            InventoryList: [],
            isEdit: false,
            REF_ID: "",

            SALE_WEEK: weekId,
            shopPaymentDays: shopPaymentDays,

            rateEditable: -1,
            quantityEditable: -1,
            editObj: {
                idx: "",
                label: "",
                value: ""
            }
        };
        this.gridRef = React.createRef(null);
    }


    // componentDidMount() {
    //     this.getRecord()
    //     this.getInventory()
    // }

    async getRecord(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_WH_ID: localStorage.getItem('PC_GRP_ATT'),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset,
        };
        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/WarehouseModule/PCGetGridWHRefundItem.php`, formData);
        let SaleData = getAllSale.data
        let SaleList = []
        if (SaleData.success === 1) {
            SaleList = SaleData.data
            pagination.totalItems = parseInt(SaleData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ SaleList })
        this.props.toggleLoader(false)
    }

    async getInventory() {
        if (_inventoryCache) {
            this.setState(_inventoryCache);
            return;
        }
        let formData = {
            PC_WH_ID: localStorage.getItem('PC_GRP_ATT')
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getAllWarehouseInventory.php`, formData);
        let serviceData = getAllInventory.data
        let ItemList = []
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                ItemList.push({
                    'label': `${element.DEVICE_ID || ""} ${element.INV_ITEM_NAME}`,
                    'value': element.INV_ID + "||" + element.INV_ITEM_NAME,
                    'id': element.INV_ID
                })
            }
        }
        _inventoryCache = { InventoryList, ItemList };
        this.setState({ InventoryList, ItemList })
    }

    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.PC_SP_ID,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList })
    }

    async hanldeAddSale() {
        let dateObj = new Date();
        let { weekId, dates } = getWeekDetails(dateObj);
        let shopPaymentDays = dates.map(d => ({ DateAndDay: d }));
        this.setState({
            shopPaymentDays,
            addSale: true,
            isEdit: false,
            SALE_WEEK: weekId,
            Date: formatDate(dateObj.toDateString()),
            Description: ""
        })

        this.getInventory()
        this.getShopList()
    }

    handleSearchgridData() {

    }

    handleUpdateSale(historyRow) {
        let SaleData = historyRow
        let Customer = SaleData.REF_CUSTOMER;
        let shpValue = { value: Customer, label: SaleData.REF_TO }
        this.setState({
            isEdit: true,
            addSale: true,
            REF_ID: SaleData.REF_ID,

            Customer: Customer,
            SaleToShop: shpValue,
            SALE_TO_TYPE: SaleData.REF_TO_TYPE,

            SALE_WEEK: SaleData.REF_WEEK,
            Date: formatDate(SaleData.REF_DATE),
            AddedItemList: JSON.parse(SaleData.REF_ITEM),
            shopPaymentDays: JSON.parse(SaleData.REF_DAY),
            Description: ""
        })
    }

    handleDelete(historyRow) {
        Swal.fire({
            title: 'Delete this refund?',
            text: 'This will reverse its inventory and delivery adjustments.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (!result.isConfirmed) return;
            this.props.toggleLoader(true);
            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}services/delete/WarehouseModule/DeleteWHRefundItem.php`,
                    { REF_ID: historyRow.REF_ID, REF_WH_ID: historyRow.REF_WH_ID }
                );
                if (res.data.success === 1) {
                    Swal.fire('Deleted', res.data.message, 'success');
                    this.getRecord();
                } else {
                    Swal.fire('Error', res.data.message, 'error');
                }
            } catch (error) {
                console.error('handleDelete error :>> ', error);
                Swal.fire('Error', 'Failed to delete refund', 'error');
            } finally {
                this.props.toggleLoader(false);
            }
        });
    }

    handleChangeTotalRecords() {

    }

    handleChangePagination() {

    }

    handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item, InventoryList } = this.state;
        switch (fieldName) {
            case 'ItemName':
                let findInventory = InventoryList.filter(x => x.INV_ID === evt.id)?.[0]
                Item['ItemName'] = evt
                Item['ItemRate'] = parseFloat(findInventory.PC_WH_ITEM_SELL_RATE).toFixed(2)
                Item['ItemAmount'] = parseFloat(findInventory.PC_WH_ITEM_SELL_RATE).toFixed(2)
                Item['ItemIMEI'] = findInventory.INV_BARCODE
                Item['ItemDesc'] = findInventory.INV_DESC
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                break;

            case 'ItemDisType':
                Item['ItemDisType'] = evtA
                if (evtA === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;
            case 'ItemQuantity':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((evt.target.value * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((evt.target.value * Item['ItemRate']) - ((evt.target.value * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;
            case 'ItemRate':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * evt.target.value) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * evt.target.value) - ((Item['ItemQuantity'] * evt.target.value) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;

            case 'ItemDisc':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - evt.target.value).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (evt.target.value / 100))).toFixed(2)
                }
                break;

            case 'ItemIMEI':
                Item[fieldName] = evt.target.value
                break;

            default:
                Item[fieldName] = evt.target.value
                break;

        }
        this.setState({ Item })
    }


    handleValidateItem(Item) {
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select Item',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseFloat(Item.ItemRate).toFixed(2) <= 0.00) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }

        return true
    }

    handleAddItem() {
        let { Item, AddedItemList } = this.state
        if (!this.handleValidateItem(Item)) return
        let checkIfItemAvailable = AddedItemList.filter(x => x.ItemName.id === Item.ItemName.id)
        let CheckIndex = AddedItemList.findIndex(x => x.ItemName.id === Item.ItemName.id);
        if (checkIfItemAvailable.length > 0) {
            let AddedItemContent = checkIfItemAvailable[0]
            let CalculatedQuantity = parseInt(AddedItemContent['ItemQuantity']) + parseInt(Item['ItemQuantity']);
            AddedItemList[CheckIndex]['ItemDesc'] = Item['ItemDesc'];
            AddedItemList[CheckIndex]['ItemDisc'] = Item['ItemDisc'];
            AddedItemList[CheckIndex]['ItemDisType'] = Item['ItemDisType'];
            AddedItemList[CheckIndex]['ItemRate'] = Item['ItemRate'];
            AddedItemList[CheckIndex]['ItemQuantity'] = CalculatedQuantity;

            if (Item['ItemDisType'] === 'number') {
                Item['ItemAmount'] = parseFloat((CalculatedQuantity * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
            } else {
                Item['ItemAmount'] = parseFloat((CalculatedQuantity * Item['ItemRate']) - ((CalculatedQuantity * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
            }

            AddedItemList[CheckIndex]['ItemAmount'] = parseFloat(Item['ItemAmount']).toFixed(2);
            this.setState({ AddedItemList })
        } else {
            let UpdateItemList = [Item].concat(AddedItemList)
            this.setState({ AddedItemList: UpdateItemList })
        }
        let RefreshItem = {
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemDisc: 0,
            ItemAmount: 0,
            ItemDisType: "number"
        }
        this.setState({ Item: RefreshItem })

    }

    async handleChange(fieldName, evt) {
        let value
        switch (fieldName) {
            case 'Date':
                value = evt.target.value;
                let { weekId, dates } = getWeekDetails(value);
                let shopPaymentDays = dates.map(d => ({ DateAndDay: d }));
                this.setState({
                    Date: value,
                    SALE_WEEK: weekId,
                    shopPaymentDays: shopPaymentDays
                });
                return;
            case 'SaleToShop':
                value = evt
                break;
            default:
                value = evt.target.value
                break;
        }
        this.setState({
            [fieldName]: value
        })
    }

    ValidateInvoice() {
        let { SALE_TO_TYPE } = this.state;

        if (SALE_TO_TYPE === "Customer" && this.state.Customer === "") {
            Swal.fire(
                'Error',
                'Please Enter Customer',
                'error'
            )
            return false
        }

        if (SALE_TO_TYPE === "Shop" && this.state.SaleToShop === "") {
            Swal.fire(
                'Error',
                'Please select Shop',
                'error'
            )
            return false
        }

        if (this.state.AddedItemList.length === 0) {
            Swal.fire(
                'Error',
                'Please Add atleast 1 Item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSaveInvoice() {
        if (!this.ValidateInvoice()) return

        let { SALE_TO_TYPE } = this.state
        let formData = {
            REF_ID: this.state.REF_ID,
            REF_WH_ID: localStorage.getItem('PC_GRP_ATT'),
            REF_TO_TYPE: SALE_TO_TYPE,
            REF_CUSTOMER: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.value,
            REF_TO_LABEL: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.label,
            REF_DAY: JSON.stringify(this.state.shopPaymentDays),
            REF_WEEK: this.state.SALE_WEEK,
            REF_DATE: this.state.Date,
            REF_ITEM: JSON.stringify(this.state.AddedItemList),
            REF_TOTAL_AMT: this.renderTotalAmount()
        }
        try {
            let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/WarehouseModule/PCRefundWHItem.php`, formData);
            if (getSaleInvoiceResult.data.status === 200) {
                Swal.fire(
                    'Success',
                    getSaleInvoiceResult.data.message,
                    'success'
                )
            } else {
                Swal.fire(
                    'Error',
                    getSaleInvoiceResult.data.message,
                    'error'
                )
            }
            this.handleExit()
        } catch (error) {
            console.error('error :>> ', error);
        }
    }

    handleExit() {
        let dateObj = new Date();
        let { weekId, dates } = getWeekDetails(dateObj);
        let shopPaymentDays = dates.map(d => ({ DateAndDay: d }));
        this.setState({
            addSale: false,
            ItemList: [],

            Customer: "",
            SALE_TO_TYPE: "Customer",
            SaleToShop: "",

            Date: formatDate(dateObj.toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            isEdit: false,
            REF_ID: "",

            SALE_WEEK: weekId,
            shopPaymentDays: shopPaymentDays
        })
        this.getRecord()
    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return parseFloat(Price).toFixed(2)
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleEnterImei(evnt) {
        if (evnt.key === 'Enter') {
            let { Item, InventoryList } = this.state;

            let FilterItem = InventoryList.filter(x => x.INV_BARCODE === Item.ItemIMEI)
            if (FilterItem.length > 0) {

                Item['ItemName'] = {
                    'label': `${FilterItem[0].DEVICE_ID || ""} ${FilterItem[0].INV_ITEM_NAME}`,
                    'value': FilterItem[0].INV_ID + "||" + FilterItem[0].INV_ITEM_NAME,
                    'id': FilterItem[0].INV_ID
                }
                Item['ItemDesc'] = FilterItem[0].INV_DESC
                Item['ItemRate'] = parseFloat(FilterItem[0].PC_WH_ITEM_SELL_RATE)
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                Item['ItemAmount'] = parseFloat((1 * FilterItem[0].PC_WH_ITEM_SELL_RATE) - ((1 * FilterItem[0].PC_WH_ITEM_SELL_RATE) * (0 / 100))).toFixed(2)
            }
            this.setState({ Item }, () => { this.handleAddItem() })
        }

    }

    handleRemove(index) {
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }

    handleEditItems(index, fieldName, currntValue, evt) {
        evt.preventDefault();
        let editObj = {
            idx: index,
            label: fieldName,
            value: currntValue
        }
        let otherName = fieldName === "ItemRate" ? "quantityEditable" : "rateEditable"
        let stateName = fieldName === "ItemRate" ? "rateEditable" : "quantityEditable"
        this.setState({ [stateName]: index, [otherName]: -1, editObj })
    }

    handleChangeEditableItem(evt) {
        let { editObj } = this.state;
        editObj[evt.target.name] = evt.target.value
        this.setState({ editObj })
    }

    handleValidateUpdateItem(Item) {
        if (Item.label === "ItemRate" && (Item.value === '' || parseFloat(Item.value).toFixed(2) <= 0.00)) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.label === "ItemQuantity" && (Item.value === '' || parseInt(Item.value) <= 0)) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }
        return true
    }

    handleUpdateEditableItem(applyChange, evnt) {
        let { editObj, AddedItemList } = this.state;
        switch (applyChange) {
            case "key_press":
                if (evnt.key === 'Enter') {
                    if (!this.handleValidateUpdateItem(editObj)) return;
                    AddedItemList[editObj.idx][editObj.label] = editObj.value;
                    let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                    if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                    } else {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                    }
                    let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                    this.setState({ [stateName]: -1, AddedItemList })
                }
                break;

            default:
                if (!this.handleValidateUpdateItem(editObj)) return;
                AddedItemList[editObj.idx][editObj.label] = editObj.value;
                let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                } else {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                }
                let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                this.setState({ [stateName]: -1, AddedItemList })
                break;
        }
    }


    render() {
        const { addSale } = this.state;
        let { Item } = this.state;

        if (!addSale) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        ref={this.gridRef}
                        title="REFUND ITEM"
                        buttonLabel="REFUND"
                        onClickButton={this.hanldeAddSale.bind(this)}
                        getData={this.getRecord.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "REFUND TO", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Refund columns follow the sale/purchase standard,
                            limited to what a refund stores: no status, and device refunds record no counterparty. */}
                        {this.state.SaleList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.REF_DATE)}</TableCell>
                                <TableCell>{partyLabel(row.REF_TO, row.REF_TO_TYPE)}</TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.REF_TOTAL_AMT)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleUpdateSale.bind(this, row) },
                                        { type: 'delete', onClick: this.handleDelete.bind(this, row) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Refund Item" right={<><ToggleSwitch
                        options={['Customer', 'Shop']}
                        value={this.state.SALE_TO_TYPE}
                        onChange={val => this.setState({ SALE_TO_TYPE: val })}
                        disabled={this.state.isEdit}
                    /></>} style={{ margin: "0 0 16px" }} />

                {/* Input Card */}
                <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr', gap: 16, marginBottom: 16 }}>
                        <div>
                            <label style={LABEL}>{this.state.SALE_TO_TYPE}</label>
                            {this.state.SALE_TO_TYPE === 'Customer'
                                ? <input style={INPUT} disabled={this.state.isEdit} value={this.state.Customer} onChange={this.handleChange.bind(this, 'Customer')} />
                                : <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" isDisabled={this.state.isEdit} value={this.state.SaleToShop} options={this.state.ShopList} onChange={this.handleChange.bind(this, 'SaleToShop')} />
                            }
                        </div>
                        <div>
                            <label style={LABEL}>Date</label>
                            <input type="date" style={INPUT} disabled={this.state.isEdit} value={this.state.Date} onChange={this.handleChange.bind(this, 'Date')} />
                        </div>
                        <div>
                            <label style={LABEL}>Description</label>
                            <input style={INPUT} value={this.state.Description} onChange={this.handleChange.bind(this, 'Description')} />
                        </div>
                    </div>
                    {/* Item entry */}
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 2fr 1fr 0.7fr', gap: 12, marginBottom: 12 }}>
                        <div>
                            <label style={LABEL}>Item</label>
                            <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={Item['ItemName']} options={this.state.ItemList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                        </div>
                        <div>
                            <label style={LABEL}>IMEI / Barcode</label>
                            <input style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleEnterImei.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                        </div>
                        <div>
                            <label style={LABEL}>Rate</label>
                            <AmountInput plain style={INPUT} value={Item['ItemRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemRate')} />
                        </div>
                        <div>
                            <label style={LABEL}>Qty.</label>
                            <input type="number" style={INPUT} value={Item['ItemQuantity']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemQuantity')} />
                        </div>
                    </div>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 1fr auto auto', gap: 12, alignItems: 'flex-end' }}>
                        <div>
                            <label style={LABEL}>Item Description</label>
                            <input style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                        </div>
                        <div>
                            <label style={LABEL}>Discount</label>
                            <AmountInput plain style={INPUT} value={Item['ItemDisc']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDisc')} />
                        </div>
                        <div>
                            <label style={LABEL}>Type</label>
                            <ToggleSwitch
                                options={['£', '%']}
                                value={Item['ItemDisType'] === 'number' ? '£' : '%'}
                                onChange={val => this.setState(prev => ({ Item: { ...prev.Item, ItemDisType: val === '£' ? 'number' : 'percent' } }))}
                            />
                        </div>
                        <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                    </div>
                </div>

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small" className="pc-card-table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>RATE</TableCell>
                                <TableCell style={COL_HEAD}>QTY</TableCell>
                                <TableCell style={COL_HEAD}>DISCOUNT</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                <TableCell style={COL_HEAD}>ACTION</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{ItemDetails.ItemName?.label}</TableCell>
                                    <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                    <TableCell onDoubleClick={this.handleEditItems.bind(this, idx, 'ItemRate', ItemDetails.ItemRate)}>
                                        {this.state.rateEditable === idx
                                            ? <AmountInput name="value" value={this.state.editObj.value} size="sm" onBlur={this.handleUpdateEditableItem.bind(this, 'blur')} onKeyPress={this.handleUpdateEditableItem.bind(this, 'key_press')} onChange={this.handleChangeEditableItem.bind(this)} />
                                            : '£ ' + formatAmount(ItemDetails.ItemRate)
                                        }
                                    </TableCell>
                                    <TableCell onDoubleClick={this.handleEditItems.bind(this, idx, 'ItemQuantity', ItemDetails.ItemQuantity)}>
                                        {this.state.quantityEditable === idx
                                            ? <Form.Control name="value" value={this.state.editObj.value} size="sm" type="number" onBlur={this.handleUpdateEditableItem.bind(this, 'blur')} onKeyPress={this.handleUpdateEditableItem.bind(this, 'key_press')} onChange={this.handleChangeEditableItem.bind(this)} />
                                            : ItemDetails.ItemQuantity
                                        }
                                    </TableCell>
                                    <TableCell>{(ItemDetails.ItemDisc === '0' || ItemDetails.ItemDisc === 0) ? '' : (ItemDetails.ItemDisType === 'number' ? '£ ' + formatAmount(ItemDetails.ItemDisc) : '% ' + ItemDetails.ItemDisc)}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemAmount)}</TableCell>
                                    <TableCell>
                                        <IconButton size="small" onClick={this.handleRemove.bind(this, idx)}><RemoveIcon /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={5} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Refund</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                <td />
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', gap: 8 }}>
                    <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                    {!this.state.isEdit && (
                        <Button variant="contained" onClick={this.handleSaveInvoice.bind(this)}>SAVE</Button>
                    )}
                </div>
            </Container>
        );
    }
}
